/**
 * Portable Appliance Testing (PAT) - Validation Engine
 * Delegates pass/fail computation to the shared patEvaluator engine.
 */
import { evaluateAppliance } from '../../utils/electrical/patEvaluator.js';

export default {
  validate: (data) => {
    const errors = {};
    const warnings = {};

    // Test details
    if (!data.jobDetails?.certificateNumber?.trim()) {
      errors.certificateNumber = 'Certificate / register number is required';
    }
    if (!data.jobDetails?.testDate) {
      errors.testDate = 'Test date is required';
    }
    if (!data.jobDetails?.dutyHolder?.trim()) {
      errors.dutyHolder = 'Duty holder is required';
    }
    if (!data.jobDetails?.testLocation?.trim()) {
      errors.testLocation = 'Test location is required';
    }
    if (!data.jobDetails?.companyName?.trim()) {
      errors.companyName = 'Testing company is required';
    }
    if (!data.jobDetails?.engineerName?.trim()) {
      errors.engineerName = 'Engineer name is required';
    }
    if (!data.jobDetails?.engineerCardNumber?.trim()) {
      errors.engineerCardNumber = 'Engineer card number is required';
    }

    // Test equipment
    if (!data.testEquipment || data.testEquipment.length === 0) {
      errors.testEquipment = 'At least one item of test equipment must be recorded';
    } else {
      data.testEquipment.forEach((eq, index) => {
        if (!eq.equipmentSerial?.trim()) {
          errors[`testEquipment_${index}_serial`] = 'Equipment serial number is required';
        }
      });
    }

    // Appliances
    if (!data.appliances || data.appliances.length === 0) {
      errors.appliances = 'At least one appliance must be recorded';
    } else {
      data.appliances.forEach((appliance, index) => {
        const prefix = `appliance_${index}`;

        if (!appliance.description?.trim()) {
          errors[`${prefix}_description`] = 'Item description is required';
        }
        if (!appliance.applianceClass) {
          errors[`${prefix}_applianceClass`] = 'Appliance class is required';
        }
        if (!appliance.visualInspection) {
          errors[`${prefix}_visualInspection`] = 'Visual inspection result is required';
        }

        // Auto-evaluate the appliance against class thresholds
        const { status, failures } = evaluateAppliance(appliance);
        appliance.evaluation = { status, failures };

        // If the auto-evaluator flags a FAIL but the recorded result says PASS, warn
        if (failures.length > 0 && appliance.testResult === 'PASS') {
          warnings[`${prefix}_testResult`] =
            `Item marked PASS but measurements indicate failure: ${failures.join('; ')}.`;
        }
        if (failures.length === 0 && appliance.testResult === 'FAIL') {
          warnings[`${prefix}_testResult`] =
            'Item marked FAIL but measurements appear within limits.';
        }
        if (!appliance.testResult) {
          errors[`${prefix}_testResult`] = 'Overall result is required';
        }
      });
    }

    return {
      isValid: Object.keys(errors).length === 0,
      errors,
      warnings
    };
  }
};